/* ============================================================
   A.B.M Cabinets — doubao theme (Shopify)
   Interaction layer only. Page markup is rendered by Liquid.
   Cart is driven by the Shopify Cart API (/cart.js, /cart/add.js).
   ============================================================ */
(function () {
  "use strict";

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- Cart (Cart API) ---------- */
  var DRAWER_OPEN = false;

  function money(n) {
    var v = (n || 0) / 100;
    return "$" + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function loadCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function updateBadge(cart) {
    var n = cart ? cart.item_count : 0;
    var el = $("#cartCount");
    if (el) {
      el.textContent = n;
      el.classList.toggle("hidden", n === 0);
    }
    var dc = $("#drawerCount");
    if (dc) dc.textContent = n;
  }

  function renderDrawer(cart) {
    var body = $("#drawerBody");
    if (!body) return;
    var hasItems = cart.items && cart.items.length > 0;
    document.body.classList.toggle("cart-has-items", !!hasItems);
    if (!hasItems) {
      body.innerHTML = '<div class="drawer-empty">Your cart is empty.<br><a href="/collections/all" data-link>Shop cabinets</a></div>';
      updateBadge(cart);
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var line = "—";
      if (it.variant_title && it.variant_title !== "Default Title") line = it.variant_title;
      return '<div class="drawer-item" data-key="' + it.key + '">' +
        '<a class="di-img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="">' : "") + "</a>" +
        '<div class="di-info">' +
        "<b>" + it.product_title + "</b>" +
        (line !== "—" ? "<span>" + line + "</span>" : "") +
        '<div class="di-qty"><button class="di-q" data-key="' + it.key + '" data-d="-1" aria-label="Decrease">−</button><b>' + it.quantity + '</b><button class="di-q" data-key="' + it.key + '" data-d="1" aria-label="Increase">+</button></div>' +
        "</div>" +
        '<div class="di-right"><span>' + money(it.line_price) + '</span><button class="di-remove" data-key="' + it.key + '" aria-label="Remove">✕</button></div>' +
        "</div>";
    }).join("");

    /* foot totals + free-ship bar */
    var threshold = parseFloat((($("#drawerFoot") || {}).dataset ? ($("#drawerFoot").dataset.threshold || "10000") : "10000").replace(/,/g, ""));
    var fsMode = (($("#drawerFoot") || {}).dataset ? ($("#drawerFoot").dataset.freeship || "show") : "show");
    var subtotal = cart.items_subtotal_price || 0;
    var discount = cart.total_discount || 0;
    var shipEl = $("#drawerShip"), totEl = $("#drawerTotal"), subEl = $("#drawerSubtotal"), msgEl = $("#shipMsg"), barEl = $("#shipBar");
    var drRow = $("#drawerDiscountRow"), drEl = $("#drawerDiscount");
    if (subEl) subEl.textContent = money(subtotal);
    if (drRow && drEl) {
      if (discount > 0) { drRow.style.display = ""; drEl.textContent = "−" + money(discount); }
      else { drRow.style.display = "none"; }
    }
    if (shipEl) shipEl.textContent = subtotal >= threshold ? "Free" : "Calculated at checkout";
    if (totEl) totEl.textContent = money(subtotal - discount);
    if (msgEl) {
      if (subtotal >= threshold) {
        if (fsMode === "bar_only") { msgEl.textContent = ""; msgEl.style.display = "none"; }
        else { msgEl.textContent = "You've unlocked FREE shipping!"; msgEl.style.display = ""; }
      } else {
        msgEl.textContent = "Free shipping over $" + threshold.toLocaleString("en-US") + " — add $" + (threshold - subtotal).toLocaleString("en-US") + " more";
        msgEl.style.display = "";
      }
    }
    if (barEl) barEl.style.width = Math.min(100, Math.round(subtotal / threshold * 100)) + "%";
    updateBadge(cart);
    bindDrawerActions();
  }

  function bindDrawerActions() {
    $$(".di-q", $("#drawerBody")).forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.dataset.key, d = parseInt(b.dataset.d, 10);
        loadCart().then(function (cart) {
          var it = cart.items.find(function (i) { return i.key === key; });
          if (!it) return;
          var q = Math.max(1, it.quantity + d);
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ id: key, quantity: q })
          }).then(function (r) { return r.json(); }).then(function (c) { renderDrawer(c); toast("Cart updated"); });
        });
      });
    });
    $$(".di-remove", $("#drawerBody")).forEach(function (b) {
      b.addEventListener("click", function () {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: b.dataset.key, quantity: 0 })
        }).then(function (r) { return r.json(); }).then(function (c) { renderDrawer(c); toast("Item removed"); });
      });
    });
  }

  function openCart() {
    DRAWER_OPEN = true;
    var d = $("#cartDrawer"), o = $("#overlay");
    if (d) d.classList.add("open");
    if (o) o.classList.add("show");
    document.body.classList.add("drawer-open");
    loadCart().then(renderDrawer).catch(function () {});
  }
  function closeCart() {
    DRAWER_OPEN = false;
    var d = $("#cartDrawer"), o = $("#overlay");
    if (d) d.classList.remove("open");
    if (o) o.classList.remove("show");
    document.body.classList.remove("drawer-open");
  }

  /* AJAX add to cart for any form[action*="/cart/add"] */
  function bindAddForms() {
    $$('form[action*="/cart/add"]').forEach(function (f) {
      f.addEventListener("submit", function (ev) {
        ev.preventDefault();
        var btn = f.querySelector('button[type="submit"]');
        if (btn && btn.disabled) return;
        var fd = new FormData(f);
        if (!fd.get("quantity")) fd.set("quantity", "1");
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: fd
        }).then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        }).then(function () {
          toast("Added to cart");
          openCart();
        }).catch(function () {
          toast("Please choose all options first");
        });
      });
    });
  }

  function openDrawerShell() {
    var d = $("#cartDrawer"), o = $("#overlay");
    if (d) d.classList.add("open");
    if (o) o.classList.add("show");
    document.body.classList.add("drawer-open");
  }

  /* ---------- Promo code (applied via Cart API discount_code) ---------- */
  function bindPromo() {
    var btn = $("#promoBtn"), input = $("#promoInput"), msg = $("#promoMsg");
    if (!btn || !input || !msg) return;
    btn.addEventListener("click", function () {
      var code = input.value.trim();
      if (!code) {
        msg.className = "promo-msg err"; msg.textContent = "Enter a promo code"; msg.style.display = "block";
        return;
      }
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ discount_code: code })
      }).then(function (r) {
        if (!r.ok) throw new Error("bad code");
        return r.json();
      }).then(function (c) {
        msg.className = "promo-msg ok"; msg.textContent = "Promo applied — discount reflected below"; msg.style.display = "block";
        renderDrawer(c);
      }).catch(function () {
        msg.className = "promo-msg err"; msg.textContent = "That code isn't valid. Try CABINET10."; msg.style.display = "block";
        loadCart().then(renderDrawer).catch(function () {});
      });
    });
  }

  /* ---------- Scenarios (home interactive) ---------- */
  var _scenTimer = null;
  function initScenarios() {
    if (_scenTimer) { clearInterval(_scenTimer); _scenTimer = null; }
    var stage = $("[data-scenarios] .scen-stage");
    if (!stage) return;
    var frames = $$(".scen-frame", stage);
    var rows = $$("[data-scenarios] .scen-row");
    var tabs = $("[data-scenarios] .scen-tabs");
    var idxEl = $(".scen-stage-idx", stage);
    var nameEl = $(".scen-stage-name", stage);
    var bar = $(".scen-progress", stage);
    var playBtn = $(".scen-autoplay", stage);
    if (!frames.length) return;
    var N = frames.length, DURATION = 5000, active = 0, playing = true;

    function restart() {
      if (!bar) return;
      bar.classList.remove("run");
      void bar.offsetWidth;
      bar.classList.add("run");
    }
    function select(i) {
      i = ((i % N) + N) % N;
      active = i;
      frames.forEach(function (f, k) { f.classList.toggle("is-active", k === i); });
      rows.forEach(function (r, k) { r.classList.toggle("is-active", k === i); r.setAttribute("aria-selected", k === i ? "true" : "false"); });
      if (idxEl) idxEl.textContent = String(i + 1).padStart(2, "0");
      if (nameEl) nameEl.textContent = frames[i].getAttribute("data-title") || "";
      restart();
    }
    function start() {
      if (_scenTimer) return;
      playing = true;
      if (playBtn) { playBtn.classList.add("on"); playBtn.setAttribute("aria-label", "Pause auto-rotation"); }
      if (bar) bar.classList.add("run");
      _scenTimer = setInterval(function () { select(active + 1); }, DURATION);
    }
    function stop() {
      if (_scenTimer) { clearInterval(_scenTimer); _scenTimer = null; }
      playing = false;
      if (playBtn) { playBtn.classList.remove("on"); playBtn.setAttribute("aria-label", "Play auto-rotation"); }
      if (bar) bar.classList.remove("run");
    }
    rows.forEach(function (r) {
      r.addEventListener("click", function () { select(parseInt(r.getAttribute("data-i"), 10)); stop(); });
    });
    if (playBtn) playBtn.addEventListener("click", function (e) { e.stopPropagation(); playing ? stop() : start(); });
    if (tabs) tabs.addEventListener("keydown", function (e) {
      var n = -1;
      if (e.key === "ArrowDown" || e.key === "ArrowRight") n = active + 1;
      else if (e.key === "ArrowUp" || e.key === "ArrowLeft") n = active - 1;
      else if (e.key === "Home") n = 0;
      else if (e.key === "End") n = N - 1;
      else return;
      e.preventDefault();
      select(n); stop();
      if (rows[n]) rows[n].focus();
    });
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) stop();
    else start();
  }

  /* ---------- Collection filters + sort ---------- */
  function initFilters() {
    var grid = $("#productGrid");
    if (!grid) return;
    var state = { color: "", type: "", sort: "featured" };

    function apply() {
      var items = $$(".grid-item", grid);
      var visible = items.filter(function (el) {
        var c = el.dataset.color || "", t = el.dataset.type || "";
        if (state.color && c !== state.color) return false;
        if (state.type && t !== state.type) return false;
        return true;
      });
      items.forEach(function (el) { el.style.display = "none"; });
      visible.forEach(function (el) { el.style.display = ""; });
      var none = $(".filter-empty", grid.parentNode);
      if (!none) {
        none = document.createElement("p");
        none.className = "empty-note filter-empty";
        none.textContent = "No cabinets match these filters.";
        grid.parentNode.insertBefore(none, grid.nextSibling);
      }
      none.style.display = visible.length ? "none" : "";
      sortVisible(visible);
    }
    function sortVisible(visible) {
      var s = state.sort;
      if (s === "featured") return;
      var map = { "price-asc": function (a, b) { return a.price - b.price; },
                  "price-desc": function (a, b) { return b.price - a.price; },
                  "title-asc": function (a, b) { return (a.title || "").localeCompare(b.title || ""); } };
      var fn = map[s];
      if (!fn) return;
      var data = visible.map(function (el) {
        return { el: el, price: parseFloat(el.dataset.price || "0"), title: (el.querySelector(".pc-name") || {}).textContent || "" };
      });
      data.sort(fn);
      data.forEach(function (d) { grid.appendChild(d.el); });
    }

    $$("#shopToolbar .chip").forEach(function (chip) {
      chip.addEventListener("click", function () {
        var grp = chip.dataset.filter, val = chip.dataset.value;
        $$("#shopToolbar .chip[data-filter='" + grp + "']").forEach(function (c) { c.classList.remove("on"); });
        chip.classList.add("on");
        state[grp] = val;
        apply();
      });
    });
    var sortSel = $("#sortSelect");
    if (sortSel) sortSel.addEventListener("change", function () {
      state.sort = sortSel.value;
      apply();
    });
  }

  /* ---------- Product variant selection ---------- */
  function initVariants() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !form.dataset.variants) return;
    var variants = JSON.parse(form.dataset.variants);
    function sync() {
      var sel = { 1: "", 2: "", 3: "" };
      $$(".seg-btn", form).forEach(function (b) {
        if (b.classList.contains("on")) sel[b.dataset.option] = b.dataset.value;
      });
      var v = variants.find(function (vv) {
        return vv.options.every(function (o, i) { return o === (sel[i + 1] || ""); });
      });
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector("[data-price-target]");
      var badge = document.getElementById("dgBadge");
      if (v && idInput) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = (priceEl.dataset.atcLabel || "Add to cart — ") + money(v.price);
        var payEl = form.querySelector("[data-pay-target]");
        if (payEl) payEl.textContent = (payEl.dataset.payPrefix || "4 interest-free installments · from $") + Math.floor(v.price / 400) + (payEl.dataset.paySuffix || "/mo");
        if (badge) badge.textContent = v.sku ? (badge.dataset.skuPrefix || "SKU ") + v.sku : (badge.dataset.noSku || "Product");
      }
    }
    $$(".seg-btn", form).forEach(function (b) {
      b.addEventListener("click", function () {
        var opt = b.dataset.option;
        $$(".seg-btn[data-option='" + opt + "']", form).forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on");
        var valEl = b.closest(".opt-label");
        sync();
      });
    });
    sync();
  }

  /* ---------- Product gallery thumbs (with prev/next carousel) ---------- */
  function initGallery() {
    var main = $("#dgMain"), mainImg = $("#dgMainImg"), badge = $("#dgBadge");
    if (!main || !mainImg) return;
    var viewport = $(".thumbs-viewport", main.parentNode);
    var track = $(".thumbs-track", main.parentNode);
    var thumbs = track ? $$(".thumb", track) : [];
    if (!viewport || !track || !thumbs.length) return;
    var prev = $(".thumb-prev", main.parentNode);
    var next = $(".thumb-next", main.parentNode);
    var PER_PAGE = 4;
    var pages = Math.max(1, Math.ceil(thumbs.length / PER_PAGE));
    var page = 0;
    function setPage(p) {
      page = Math.max(0, Math.min(p, pages - 1));
      track.style.transform = "translateX(-" + (page * viewport.offsetWidth) + "px)";
      if (prev) prev.disabled = (page === 0);
      if (next) next.disabled = (page >= pages - 1);
    }
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("on"); });
        t.classList.add("on");
        var img = t.querySelector("img");
        if (img) mainImg.src = img.getAttribute("src").replace(/width=\d+/, "width=1200");
        if (badge) badge.textContent = t.dataset.label || "View";
        var i = parseInt(t.dataset.index, 10) || 0;
        setPage(Math.floor(i / PER_PAGE));
      });
    });
    if (prev) prev.addEventListener("click", function () { setPage(page - 1); });
    if (next) next.addEventListener("click", function () { setPage(page + 1); });
    window.addEventListener("resize", function () { setPage(page); });
    // initial: snap to the page that contains the currently active thumb
    var active = track.querySelector(".thumb.on");
    if (active) {
      var idx = parseInt(active.dataset.index, 10) || 0;
      setPage(Math.floor(idx / PER_PAGE));
    } else {
      setPage(0);
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    $$(".faq-q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.parentNode;
        var open = item.classList.contains("open");
        $$(".faq-item").forEach(function (i) { i.classList.remove("open"); });
        if (!open) item.classList.add("open");
      });
    });
  }

  /* ---------- Mobile nav / drawer / misc ---------- */
  function initNav() {
    var burger = $("#burgerBtn"), nav = $("#mainNav"), overlay = $("#overlay");
    if (burger && nav) {
      burger.addEventListener("click", function () {
        nav.classList.toggle("open");
        burger.classList.toggle("on");
      });
    }
    var cartBtn = $("#cartBtn");
    if (cartBtn) cartBtn.addEventListener("click", openCart);
    var close = $("#drawerClose");
    if (close) close.addEventListener("click", closeCart);
    if (overlay) overlay.addEventListener("click", function () { closeCart(); if (nav) nav.classList.remove("open"); if (burger) burger.classList.remove("on"); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  }

  function initMisc() {
    var back = $("#backTop");
    if (back) {
      window.addEventListener("scroll", function () { back.classList.toggle("show", window.scrollY > 600); }, { passive: true });
      back.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
    }
  }

  /* ---------- Cases section lightbox (homepage blog-sourced cards) ---------- */
  function bindCaseLightbox() {
    var lbox = $("#casesLbox");
    if (!lbox) return;
    var video = $(".case-lbox-video", lbox);

    function open(src, href) {
      if (!src) return;
      video.src = src;
      video.currentTime = 0;
      lbox.hidden = false;
      lbox.setAttribute("aria-hidden", "false");
      document.body.classList.add("case-lbox-open");
      // attempt autoplay (muted) for instant feedback; ignore promise rejection
      var p = video.play();
      if (p && typeof p.catch === "function") p.catch(function () {});
      lbox._fallbackHref = href || "";
    }
    function close() {
      video.pause();
      video.removeAttribute("src");
      try { video.load(); } catch (e) {}
      lbox.hidden = true;
      lbox.setAttribute("aria-hidden", "true");
      document.body.classList.remove("case-lbox-open");
      lbox._fallbackHref = "";
    }

    $$(".case-wall .case-card[data-video]").forEach(function (card) {
      card.addEventListener("click", function (e) {
        e.preventDefault();
        open(card.getAttribute("data-video"), card.getAttribute("href"));
      });
    });
    $$("[data-lbox-close]", lbox).forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (lbox.hidden) return;
      if (e.key === "Escape") close();
    });
  }

  /* ---------- Cart page (/cart) --- quantity stepper auto-submit ---------- */
  function bindCartPage() {
    var items = $("#cartItems");
    if (!items) return;
    var form = items.querySelector("form");
    var pending = null;
    function submitLine(lineKey) {
      if (!form) return;
      if (pending && pending.__lineKey === lineKey) {
        clearTimeout(pending.__t);
        pending = null;
      }
      var t = setTimeout(function () {
        var inputs = $$('input[name="updates[]"]', form);
        inputs.forEach(function (i) { i.form && i.form.submit; });
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      }, 350);
      pending = { __lineKey: lineKey, __t: t };
    }
    $$("[data-cart-qty]", items).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var dir = parseInt(btn.dataset.cartQty, 10) || 0;
        var lineKey = btn.dataset.line;
        var inp = items.querySelector('.qty-input[data-line="' + lineKey + '"]');
        if (!inp) return;
        var v = parseInt(inp.value, 10) || 0;
        if (dir > 0) v += 1; else if (dir < 0 && v > 1) v -= 1;
        inp.value = String(v);
        submitLine(lineKey);
      });
    });
    $$(".qty-input", items).forEach(function (inp) {
      inp.addEventListener("change", function () {
        if (inp.value === "" || parseInt(inp.value, 10) < 1) inp.value = "1";
        submitLine(inp.dataset.line);
      });
    });
  }

  /* ---------- Init ---------- */
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    initNav();
    initMisc();
    initScenarios();
    initFilters();
    initVariants();
    initGallery();
    initFaq();
    bindAddForms();
    bindPromo();
    bindCaseLightbox();
    bindCartPage();
    loadCart().then(function (c) { updateBadge(c); }).catch(function () {});
  });
})();
